import React from 'react'
import PropTypes from 'prop-types'
import ArrowRightAlt from '@mui/icons-material/ArrowRightAlt'

const ArrowRightAltIcon = ({ height, width, ...more }) => {
	
	return (
		<ArrowRightAlt
			height={height}
			width={width}
			{...more}
		/>
	)
}

ArrowRightAltIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default ArrowRightAltIcon
